export const mission_join_introduction = 'Mission et Adhésion';

export const mission = {
    title: 'Mission',
    detail: 'Accroître le nombre de personnes ayant accès aux services financiers.'
}

export const join = {
    title: "Conditions d'Adhésion",
    conditions : [
        'Une photocopie de la CNIB ou du passeport',
        "Deux photos d'identité",
        "Frais d'ouverture"
    ]
}

export const services_products_introduction = 'Devenez membres et bénéficiez de nos services suivants'

export const services_introduction = 'Services'

export const services = [
    "Ouverture de compte courant et à terme avec les meilleurs taux d'intérêt",
    "Compte courant, Epargne solidaire",
    "Epargne à terme, Epargne à vue, Epargne parrainage"
]

export const products_introduction = "Produits disponibles"

export const products = [
    "Octroi de crédit productif et de consommation au plus bas taux d'intérêt de seulement 10%",
    "Accompagnement pour vos crédits et projets",
    "Sécurisation de vos fonds",
    "Accès illimité à vos comptes courants"
]